import { useAuth } from '../hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { customerApi } from '@vmgate/common';
import { LoadingScreen } from '../components/common/LoadingScreen';
import { ErrorState } from '../components/common/ErrorState';
import { StatusBadge } from '../components/common/StatusBadge';
import { formatDateTime } from '../utils/format';

export function DevicesPage() {
  const { account } = useAuth();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['customer-devices', account?.customer_id],
    queryFn: () => customerApi.getCustomerDevices(account!.customer_id),
    enabled: Boolean(account?.customer_id)
  });

  if (!account || isLoading) {
    return <LoadingScreen message="Loading devices..." />;
  }

  if (isError || !data) {
    return <ErrorState message="Unable to load device list." onRetry={() => refetch()} />;
  }

  return (
    <div className="surface" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <header>
        <h2 style={{ margin: 0 }}>Registered devices</h2>
        <p className="text-muted" style={{ margin: 0 }}>
          All devices currently known to VMGate for your account.
        </p>
      </header>

      <div style={{ overflowX: 'auto' }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Device ID</th>
              <th>Brand & Model</th>
              <th>Status</th>
              <th>Android ID</th>
              <th>Certificate email</th>
              <th>Registered</th>
            </tr>
          </thead>
          <tbody>
            {data.devices.map((device) => (
              <tr key={device.device_id}>
                <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{device.device_id}</td>
                <td>
                  <div>{device.build_brand ?? 'Device'}</div>
                  <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                    {device.build_model ?? ''}
                  </div>
                </td>
                <td>
                  <StatusBadge
                    label={device.status}
                    tone={device.status === 'LICENSED' ? 'success' : device.status === 'REVOKED' ? 'danger' : 'info'}
                  />
                </td>
                <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{device.android_id}</td>
                <td>{device.certificate_email || '—'}</td>
                <td>{formatDateTime(device.registered_at)}</td>
              </tr>
            ))}
            {data.devices.length === 0 && (
              <tr>
                <td colSpan={6} className="text-muted" style={{ textAlign: 'center', padding: '1rem' }}>
                  No devices registered yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

